/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import dayjs from 'dayjs';
import { FC } from 'react';

import { Carousel } from '@mantine/carousel';
import { Box, Flex, LoadingOverlay, Text } from '@mantine/core';

import { useQuery } from '@tanstack/react-query';

import { bookingApi } from '@/shared/api/booking.ts';
import { bookingObjectsApi } from '@/shared/api/bookingObjects.ts';
import { getObjectHierarchy } from '@/shared/helpers/utils.ts';
import { useGetBookingTypeData } from '@/shared/hooks/useGetBookingTypeData';
import { PersonBookingsObject } from '@/shared/types/booking.types';
import { CopyButton } from '@/shared/uikit/components/button/CopyButton';
import { MapButton } from '@/shared/uikit/components/button/mapButton';
import { ContentCheckbox } from '@/shared/uikit/components/checkbox/contentCheckbox';

import { ActiveBookingActions } from './ActiveBookingActions';

type ActiveBookingSelectedProps = {
	booking: PersonBookingsObject;
	actions: {
		type: 'cancel' | 'end';
		opened: boolean;
		close: () => void;
		closeParent?: () => void;
	};
};

export const ActiveBookingSelected: FC<ActiveBookingSelectedProps> = ({ booking, actions }) => {
	const {
		data: currentBooking = null,
		isLoading: isBookingLoading,
		isError: isBookingLoadingError,
	} = useQuery({
		queryKey: ['booking', booking.id],
		queryFn: () =>
			bookingApi.getBookingById(String(booking.id) ?? '').then((res) => ({
				...res,
				start: dayjs(res.start).toDate(),
				end: dayjs(res.end).toDate(),
			})),
		retry: 0,
	});

	const {
		data: objectParents = null,
		isLoading: isObjectParentsLoading,
		isError: isObjectParentsError,
	} = useQuery({
		queryKey: ['objectParents', booking],
		queryFn: () => bookingObjectsApi.getObjectParents(booking?.booking_object.id!),
		retry: 0,
	});

	const type = useGetBookingTypeData({
		bookingType: currentBooking?.booking_object.type.kind ?? 'work_place',
	});

	// const getBookingParentNames = (booking: IBookingObjects, names: string[]): string => {
	// 	if (!booking.parent) {
	// 		return names.reverse().join(' • ');
	// 	} else {
	// 		const n = names ?? [];
	// 		n.push(booking.parent.name);
	// 		return getBookingParentNames(booking.parent, n);
	// 	}
	// };

	return (
		<Box pos="relative">
			<LoadingOverlay
				visible={isBookingLoading}
				zIndex={1000}
				overlayProps={{ radius: 2, blur: 2 }}
			/>
			{currentBooking && (
				<>
					<Flex direction="column" gap={24}>
						<Carousel
							withControls={false}
							w="100%"
							slidesToScroll="auto"
							slideSize="auto"
							slideGap={8}
							align="start"
						>
							<Carousel.Slide>
								<ContentCheckbox label={type?.label} leftIcon={type?.icon} checked />
							</Carousel.Slide>
						</Carousel>
						<Flex direction="column" gap={8}>
							<Text size="xl" fw={800}>
								Дата и время
							</Text>
							<Flex gap={16}>
								<Flex direction="column">
									<Text c="#667085" size="sm" fw={500} tt="uppercase">
										Дата
									</Text>
									<Text fw={600}>
										{dayjs(currentBooking.start).date() === dayjs(currentBooking.end).date()
											? `${dayjs(currentBooking.start).format('DD MMM')}`
											: `С ${dayjs(currentBooking.start).format('DD MMM')} до ${dayjs(currentBooking.end).format('DD MMM')}`}
									</Text>
								</Flex>
								<Flex direction="column">
									<Text c="#667085" size="sm" fw={500} tt="uppercase">
										Время
									</Text>
									<Text fw={600}>
										{`${dayjs(currentBooking.start).format('HH:mm')} - ${dayjs(currentBooking.end).format('HH:mm')}`}
									</Text>
								</Flex>
							</Flex>
						</Flex>
						<Flex direction="column" gap={8}>
							<Text size="xl" fw={800}>
								Локация
							</Text>
							<Flex gap={16}>
								<Flex direction="column">
									<Text c="#667085" size="sm" fw={500} tt="uppercase">
										Офис и этаж
									</Text>
									<Text fw={600}>{objectParents ? getObjectHierarchy(objectParents) : ''}</Text>
								</Flex>
							</Flex>
							<Flex gap={16}>
								<Flex direction="column">
									<Text c="#667085" size="sm" fw={500} tt="uppercase">
										{type?.label}
									</Text>
									<Text fw={600}>
										{
											//TODO: edit response to get work place/parking/meeting room number
											currentBooking.booking_object.name.replace(/([\s|А-Яа-я]+)|(\d-)/gm, '')
										}
									</Text>
								</Flex>
							</Flex>
							{(type?.type === 'parking_place' || type?.type === 'work_park') && (
								<Flex gap={16}>
									<Flex direction="column">
										<Text c="#667085" size="sm" fw={500} tt="uppercase">
											Номер автомобиля
										</Text>
										<Text fw={600}>{currentBooking?.car_number}</Text>
									</Flex>
								</Flex>
							)}

							{currentBooking?.booking_object.is_external && (
								<Flex direction="column">
									<Text c="#667085" size="sm" fw={500} tt="uppercase">
										Ссылка на встречу
									</Text>
									<Flex align="center">
										<Text
											fw={600}
											truncate
										>{`${window.location.origin}/booking/invite/${currentBooking.id}`}</Text>
										<CopyButton
											value={`${window.location.origin}/booking/invite/${currentBooking.id}`}
										/>
									</Flex>
								</Flex>
							)}
						</Flex>

						<MapButton objects={currentBooking.booking_object} text="Открыть на карте" showOnMap />
					</Flex>

					<ActiveBookingActions
						bookingId={currentBooking.id}
						type={actions.type}
						opened={actions.opened}
						close={actions.close}
						closeParent={actions.closeParent}
					/>
				</>
			)}
		</Box>
	);
};
